import React, { memo } from 'react';
import Enabled from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from '@lifesize/ux-assets';

export interface MicLevelProps {
  micLevel: number;
}

const micStyles = makeStyles((theme: Theme) => ({
  micLevel: {
    background: `linear-gradient(${theme.palette.primary.contrastText} 50%, ${colors.agileGreen} 50%)`,
    backgroundPosition: (config: MicLevelProps) => `left 0px top ${config.micLevel || 0}%`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 200%',
    height: 37,
    width: 37,
    opacity: 1,
    transition: 'background-position 0.2s',
    '-webkit-mask-image': `url(${Enabled})`,
    '-webkit-mask-mode': 'alpha',
    '-webkit-mask-position': 'center',
    '-webkit-mask-repeat': 'no-repeat',
    '-webkit-mask-size': 37
  }
}));

const MicLevel = (props: MicLevelProps) => {
  const audioClasses = micStyles(props);
  return <div className={audioClasses.micLevel} data-testid="mic-level" />;
};

export default memo(MicLevel);
